// src/services/BugReportService.js
import { collection, doc, setDoc, getDocs, updateDoc, query, orderBy } from 'firebase/firestore';
import { db } from './firebaseConfig';

const BugReportService = {
  // Submit a new bug report
  async submitBugReport(restaurantId, restaurantName, reportData) {
    try {
      const bugId = `bug_${Date.now()}`;
      const bugReport = {
        id: bugId,
        restaurantId,
        restaurantName,
        title: reportData.title,
        description: reportData.description,
        priority: reportData.priority || 'Medium',
        category: reportData.category || 'General',
        status: 'Open',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        resolvedAt: null,
        notes: ''
      };

      const bugRef = doc(db, 'bugReports', bugId);
      await setDoc(bugRef, bugReport);

       
      return { success: true, bugId };
    } catch (error) {
      console.error('❌ Error submitting bug report:', error);
      throw error;
    }
  },

  // Get all bug reports (for super admin)
  async getAllBugReports() {
    try {
      const bugsQuery = query(
        collection(db, 'bugReports'),
        orderBy('createdAt', 'desc')
      );
      const snapshot = await getDocs(bugsQuery);
      
      const bugs = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

       
      return bugs;
    } catch (error) {
      console.error('❌ Error loading bug reports:', error);
      return [];
    }
  },

  // Get bug reports for a specific restaurant
  async getRestaurantBugReports(restaurantId) {
    try {
      const snapshot = await getDocs(collection(db, 'bugReports'));
      
      const bugs = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(bug => bug.restaurantId === restaurantId)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

       
      return bugs;
    } catch (error) {
      console.error('❌ Error loading restaurant bug reports:', error);
      return [];
    }
  },

  // Update bug status (for super admin)
  async updateBugStatus(bugId, status, notes = '') {
    try {
      const bugRef = doc(db, 'bugReports', bugId);
      const updateData = {
        status,
        updatedAt: new Date().toISOString()
      };

      if (notes) {
        updateData.notes = notes;
      }

      if (status === 'Resolved' || status === 'Closed') {
        updateData.resolvedAt = new Date().toISOString();
      }

      await updateDoc(bugRef, updateData);

       
      return { success: true };
    } catch (error) {
      console.error('❌ Error updating bug status:', error);
      throw error;
    }
  }
};

export default BugReportService;